import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
export function Redirect(props) { var nav = useNavigate(); useEffect(function () { nav(props.to); }, [nav, props.to]); return null; }
